// @ts-nocheck
import React from 'react';
import AffiliatePayoutsTab from '@/components/affiliate/AffiliatePayoutsTab';
import StripeConnectOnboarding from '@/components/affiliate/StripeConnectOnboarding';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

const Payouts = () => {
  const { profile } = useAuth();

  const { data: affiliate, refetch: refetchAffiliate } = useQuery({
    queryKey: ['affiliate-data', profile?.id],
    queryFn: async () => {
      if (!profile?.id) return null;
      
      const { data, error } = await supabase
        .from('affiliates')
        .select('*')
        .eq('user_id', profile.user_id)
        .single();

      if (error && error.code !== 'PGRST116') throw error;
      return data;
    },
    enabled: !!profile?.id
  });

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-primary-700">Payouts</h1>
        <p className="text-gray-600">
          View your commission payouts and payment history
        </p>
      </div>

      {affiliate && (
        <StripeConnectOnboarding 
          affiliate={affiliate} 
          onAccountConnected={refetchAffiliate}
        />
      )}

      <AffiliatePayoutsTab />
    </div>
  );
};

export default Payouts;
